<template>
  <div class="order-list">
    <div class="order-item mb10" @click="goToDetail(item)" v-for="(item) in orderList" :key="item.orderId">
      <h3 class="mb12 order-name">{{item.goodsName}}</h3>
      <p class="mb5">{{ item.createTime | filterTime }}</p>
      <p class="mb5">{{$t('order.orderList.amount_paid')}} {{item.amountText}}</p>
      <p v-if="item.groupVO && item.groupVO.displayType">{{$t('order.orderList.device')}} {{item.groupVO.displayType}}</p>
      <div class="status-box">
        <span v-if="'UNPAID' !== item.orderStatus" class="status-text">{{getLabel(item.orderStatus)}}</span>
      </div>
      <div class="btn-box">
        <van-button v-if="'UNPAID' === item.orderStatus" class="cancelBtn" round @click.stop="cancelOrder(item)">{{ $t('registerlogin.cancel') }}</van-button>
        <van-button v-if="'UNPAID' === item.orderStatus" class="buyBtn" round type="info" @click.stop="gotoPay(item)">{{ $t('packages.detail.pay') }}</van-button>
      </div>
    </div>
    <div v-if="orderList.length===0" class="no-data-box">
      <span class="title">{{$t('home.no_data')}}</span>
    </div>
  </div>
</template>

<script>
import cookie from "@/utils/cookie";
import dateUtil from "@/utils/DateUtil";
import { pay as payFun } from '@/views/pay/pay';
export default {
    name: 'orderListPage',
    data() {
        return {
            orderList: [],
            statusList: [
                {value: 'UNPAID', label: this.$t('order.orderList.status_pending')},
                {value: 'CANCEL', label: this.$t('order.orderList.status_unsub')},
                {value: 'FINISHED', label: this.$t('order.orderList.status_success')},
                {value: 'CLOSE', label: this.$t('order.orderList.status_cancel')},
            ]
        }
    },
    mounted() {
      this.getOrderList();
    },
    filters:{
        filterTime(time) {
            if (!time) return "";
            let dateFormat = 'yyyy/MM/dd HH:mm'
            let langType = cookie.getCookie('langType')
            if(['es-ES','pt-PT','de-DE','fr-FR','it-IT','tr-TR'].includes(langType)){
                dateFormat = 'dd/MM/yyyy HH:mm'
            }
            return dateUtil.formatDateTime(new Date(time), dateFormat);
        },
    },
    methods: { 
      goToDetail(item) {
        this.$router.push(this.$setRouteQuery({name: 'OrderListDetail',query: {orderId: item.orderId}},this));
      },
      // 转化状态
      getLabel(value) {
        const obj = this.statusList.find(item => item.value === value);
        return obj ? obj.label : value;
      },
      // 查询订单列表
      getOrderList() {
        this.$http
        .post({
          url: "/bss/app/order/queryOrderListForApp",
          data: {
            perPageCount: 1000,
            orderStatusList: ['UNPAID', 'CANCEL', 'FINISHED', 'PENDING', 'CLOSE'],
            queryLimitFlag: true,
            custTerminalFlag: 1,
            filterTopupCode: 1,
          }
        })
        .then(res => {
            if(res.data && res.data?.dataList?.length){
                this.orderList = res.data.dataList.map(item => {
                    this.doPriceStyle(item, item.amount, 'amountText');
                    return {
                        ...item,
                        goodsName: item.offerList?.[0]?.goodsName || '',
                    };
                });
            }
        })
        .catch(err => {
          this.$toast(err);
          console.log(err);
        });
      },
      // 点击支付
      gotoPay(item) {
            this.$http
              .post({
                  url: "/bss/app/order/checkOrderPayValidate",
                  data: {
                      orderId: item.orderId,
                      orderSN: item.orderSN,
                  }
              })
              .then(res => {
                  if(res.data?.orderSN && res.data?.amount){
                      // 去收银台支付
                      let packageObj = item.offerList?.[0] || {};
                      let payAgreeFlag = packageObj.payAgreeFlag == '1' && packageObj.categoryCode == 'LXCX';
                      //国家维度自定义收银台支付模板
                      let sessionStorage_UrlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
                      let countryCode = sessionStorage_UrlData.registerCountry|| 
                                          this.$projectConfig.registerCountry||
                                          sessionStorage_UrlData.placeCode||'';
                      sessionStorage.setItem('orderType','order');
                      payFun({
                          orderSn: res.data.orderSN,
                          totalAmount: res.data.amount,
                          currencyCode: res.data.currencyType,
                          orderDesc: res.data.orderDesc,
                          orderSubject: packageObj.goodsName,
                          payFunction: payAgreeFlag&&'CYCLE'||'PAY',
                          countryCode:countryCode,
                      });
                  } else {
                      this.getOrderList();
                  }
              })
              .catch(err => {
                  this.getOrderList();
                  this.$toast(err);
                  console.log(err);
              });
      },
      // 取消订单
      cancelOrder(item){
        this.$dialog.confirm({
            title:this.$t('flowDetail.tip'),
            message: this.$t('order.orderList.goto_cancel'),
            confirmButtonText:this.$t('registerlogin.confirm'),
            cancelButtonText:this.$t('registerlogin.cancel')
        }).then(() => {
            this.$http
                .post({
                    url: "/bss/app/order/cancelUnpaidOrder",
                    data: {
                        orderId: item.orderId,
                        orderSN: item.orderSN
                    }
                })
                .then(res => {
                    this.getOrderList();
                })
                .catch(err => {
                    this.$toast(err);
                    console.log(err);
                });
        }).catch(() => {
        })
      },
      doPriceStyle(item, price, key) {
          item[key] = this.globalPriceFormat(item.currencyType, price);                
      },
    }
}
</script>

<style lang="less" scoped>
@import "~@/assets/theme.less";
.mb12 {
  margin-bottom: 12px;
}
.mb10 {
  margin-bottom: 10px;
}
.mb5 {
  margin-bottom: 5px;
}
.order-list {
  font-size: 12px;
  min-height: calc(100vh);
  min-height: calc(100dvh);
  background-color: #f2f2f2;
  padding: 12px 10px 1px;
  padding-top: 90px;
  display: flex;
  flex-direction: column;
  .order-item {
    background-color: #fff;
    border-radius: 8px;
    padding: 10px;
    position: relative;
    display: flex;
    flex-direction: column;
    .order-name {
      font-size: 16px;
    }
    p {
      color: #646566;
      font-size: 12px;
    }
    .status-box {
      position: absolute;
      right: 10px;
      bottom: 10px;
      .status-text {
        display: inline-block;
        padding: 2px 8px;
        border-radius: 12px;
        font-size: 12px;
        color: #646566;
      }
      .buyBtn {
        font-size: 12px;
        background: @theme-color;
        min-width: 80px;
        height: 24px;
        line-height: 24px;
        border: none;
        color: #fff;
      } 
    }
    .btn-box {
      display: flex;
      justify-content: flex-end;
      .buyBtn {
        font-size: 12px;
        background: @theme-color;
        min-width: 80px;
        height: 24px;
        line-height: 24px;
        border: none;
        color: #fff;
      } 
      .cancelBtn {
        font-size: 12px;
        min-width: 80px;
        height: 24px;
        line-height: 24px;
        border-radius: 12px;
        border: 1px solid #e5e5e5;
        margin-left: 8px;
        margin-right: 8px;
      }
    }
  }
  .no-data-box {
      text-align: center;
      min-height: calc(100vh - 238px);
      padding-top: 230px;
      background-image: url('../../../assets/imgs/flowPackage_none@3x.png');
      background-repeat: no-repeat;
      background-position: center 90px;
      background-size: 200px 140px;
      .title{
        font-size: 14px;
        color: #333333;
        padding: 20px 16px 0;
      }
  }
}
html[dir="rtl"] .order-list {
  .order-item {
    .status-box {
      right: unset;
      left: 10px;
    }
  }
}
</style>